import { autoSaveProject } from '__editor/components/roofsSelector/components/roofsSelectorSaveLoadProject/saveProject';
import { BackgroundActionTypes } from '__editor/panelsEditor/components/background/backgroundActionsConstants';
import { PanelsActionTypes } from '__editor/panelsEditor/components/panels/panelsActionsConstants';
import { DrawingManagerActionTypes } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManagerActionsConstants';
import { getProductName } from '__common/constants/products';
import { shouldAutoSave } from '__editor/components/roofsSelector/components/roofsSelectorSaveLoadProject/utils/autosave';
import { ProjectConfigurationActionTypes } from 'projectDesign/components/projectConfiguration/projectConfigurationActionsConstants';
import { state } from '__common/store';


const MANUAL_EXPOSURE_ACTIONS = [
  PanelsActionTypes.SET_MANUAL_EXPOSURE,
  PanelsActionTypes.SET_MANUAL_EXPOSURE_BULK,
  PanelsActionTypes.CLEAR_ALL_MANUAL_EXPOSURE,
];

export const saveProjectMiddleware = store => next => action => {
  next(action);

  const { projectConfiguration: { productId, projectId } } = state();

  if (shouldSaveOnActions(action.type)) {
    const isManualExposureAction = MANUAL_EXPOSURE_ACTIONS.includes(action.type);
    const opts = isManualExposureAction ? { allowInPanelsEditor: true } : undefined;
    if (shouldAutoSave(opts)) {
      autoSaveProject(getProductName(productId), projectId, opts);
    }
  }
};

function shouldSaveOnActions(actionType) {
  const actions = [
    ProjectConfigurationActionTypes.SET_PROJECT_OPTION,
    ProjectConfigurationActionTypes.SET_PRODUCT_TITLE,
    ProjectConfigurationActionTypes.SET_ZIP_AND_ADDRESS_CODE,
    ProjectConfigurationActionTypes.SET_ENVIRONMENTAL_FACTORS,
    ProjectConfigurationActionTypes.SET_PROJECT_NAME,
    ProjectConfigurationActionTypes.SET_PROJECT_MODE,
    ProjectConfigurationActionTypes.SET_RAILS_PRODUCT_ID,
    ProjectConfigurationActionTypes.SET_SPAN,
    DrawingManagerActionTypes.DELETE_ROOF,
    DrawingManagerActionTypes.ADD_ROOF,
    DrawingManagerActionTypes.SET_ARRAY_NAME,
    BackgroundActionTypes.DEACTIVE_PANELS_EDITOR,
    ...MANUAL_EXPOSURE_ACTIONS,
  ];

  return actions.includes(actionType);
}
